import { useEffect, useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap';
import { FaAccusoft, FaAddressBook } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import AI_CompanyJobs from './AI_CompanyJobs';
import DashboardLayout from "./DashboardLayout ";
import GlobalHRSettings from './GlobalHRSettings';
import PostedJobs from './PostedJobs';

// Assuming customTabHeader is a helper function that renders tab headers with icons
const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
        <span className="me-2">
            {/* <i className={icon} /> */}
            {icon}
        </span>
        <span class="fs-6 fw-bold">{title}</span>
    </div>
);

export const AllJobs = () => {
    // Initialize state for active tab, try to load from localStorage
    const location = useLocation();
    const initialTab = location.state?.activeTab;

    const storedTab = localStorage.getItem('activeJobTab');
    const [activeTab, setActiveTab] = useState(initialTab || storedTab || 'regularJobs');

    // Function to handle tab selection and update state
    const handleTabClick = (key) => {
        setActiveTab(key);
        localStorage.setItem('activeJobTab', key);  // Store active tab in localStorage
    };

    useEffect(() => {
        // Update active tab when location state changes
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
            localStorage.setItem('activeJobTab', location.state.activeTab);
        }
    }, [location.state]);

    return (
        <DashboardLayout>
            <div className='main-content'>
                <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
                    <Col xs="auto">
                        <h2 className='text-start' style={{ marginLeft: '12px' }}>Posted Jobs</h2>
                    </Col>
                    <Col xs="auto">
                        <GlobalHRSettings />
                    </Col>
                </Row>
                <Row>
                    <Col style={{ marginLeft: '12px' }}>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={handleTabClick}
                            style={{ marginBottom: '20px' }}
                        >
                            <Tab
                                eventKey="regularJobs"
                                title={customTabHeader("Regular Jobs", <FaAddressBook />)}
                            >
                                <PostedJobs />
                            </Tab>
                          
                            <Tab
                                eventKey="AICompanyJobs"
                                title={customTabHeader("AI Company Jobs", <FaAccusoft />)}
                            >
                                <AI_CompanyJobs />
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>

            </div>
        </DashboardLayout>
    );
};
